<script>
    import { Ok } from '../lib/msgbox.js'
    import { Mediator } from '../lib/mediator'
    import { onMount } from 'svelte'

    let errMessage = ''
    let statusMessage = ''
    let infoMessage = ''
    let fn = undefined
    let loadingVisable = false

    $: {
        if (errMessage != '') {
            Ok(errMessage, `Error`, fn)

            errMessage = ''
        }
    }

    $: {
        if (infoMessage != '') {
            Ok(infoMessage, `Information`, fn)

            infoMessage = ''
        }
    }

    onMount(() => {
        Mediator.on('systemMessage', (data) => {
            if (data.hasOwnProperty('errMessage')) {
                errMessage = data.errMessage
                ui("#error", 6000)
                if (data.fn != undefined) {
                    fn = data.fn
                }
            }

            if (data.hasOwnProperty('infoMessage')) {
                infoMessage = data.infoMessage
                ui("#info", 3000)
                if (data.fn != undefined) {
                    fn = data.fn
                }
            }

            if (data.hasOwnProperty('statusMessage')) {
                statusMessage = data.statusMessage
                ui("#status", 3000)
                if (data.fn != undefined) {
                    fn = data.fn
                }
            }
        })

        Mediator.on('spinnerShow', () => {
            loadingVisable = true
        })

        Mediator.on('spinnerReset', () => {
            loadingVisable = false
        })

    })
</script>

<div>

<!--     <div style="z-index:998;" class="w3-col l11 m11 s1">
        <div class="sub_div ddt-topbar">
            {statusMessage}
        </div>
    </div>


 -->
</div>

    <div id="error" class="snackbar error">
        <span>{errMessage}</span>
    </div>

    <div id="info" class="snackbar">
        <span>{infoMessage}</span>
    </div>
    
    <div id="status" class="snackbar primary">
        <span>{statusMessage}</span>
    </div>

    {#if loadingVisable}
        <div class="loadingOverlay">
            <span class="loader"></span>
        </div>
    {/if}

<style>
.loader {
        transform: rotateZ(45deg);
        perspective: 1000px;
        border-radius: 50%;
        width: 99px;
        height: 99px;
        color: var(--primary);
      }
        .loader:before,
        .loader:after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: inherit;
          height: inherit;
          border-radius: 50%;
          transform: rotateX(70deg);
          animation: 1s spin linear infinite;
        }
        .loader:after {
          color: var(--tertiary);
          transform: rotateY(70deg);
          animation-delay: .4s;
        }

      @keyframes rotate {
        0% {
          transform: translate(-50%, -50%) rotateZ(0deg);
        }
        100% {
          transform: translate(-50%, -50%) rotateZ(360deg);
        }
      }

      @keyframes rotateccw {
        0% {
          transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
          transform: translate(-50%, -50%) rotate(-360deg);
        }
      }

      @keyframes spin {
        0%,
        100% {
          box-shadow: .2em 0px 0 0px currentcolor;
        }
        12% {
          box-shadow: .2em .2em 0 0 currentcolor;
        }
        25% {
          box-shadow: 0 .2em 0 0px currentcolor;
        }
        37% {
          box-shadow: -.2em .2em 0 0 currentcolor;
        }
        50% {
          box-shadow: -.2em 0 0 0 currentcolor;
        }
        62% {
          box-shadow: -.2em -.2em 0 0 currentcolor;
        }
        75% {
          box-shadow: 0px -.2em 0 0 currentcolor;
        }
        87% {
          box-shadow: .2em -.2em 0 0 currentcolor;
        }
      }
   

    .loadingOverlay {
        /* Position the overlay fixed to cover the entire viewport */
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000; /* Ensure it's on top of other content */
        display: flex; /* Use Flexbox for easy centering */
        justify-content: center; /* Center horizontally */
        align-items: center; /* Center vertically */
        /* Initially hide the overlay (optional, handled via JavaScript) */
        /* display: none; */
    }
</style>
